import cabinetService from './cabinetService';

export * from './types';
export default cabinetService;



// WEBPACK FOOTER //
// ./src/services/cabinet/index.ts